import React, { useEffect, useState } from "react"
import { Button, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import ViewAll from "./ViewAllView";
// import UpdateArrangeFields from "./innerComponent/UpdateArrangeFields";
import { getViewList, isJson } from "utils";
import DeleteViewModal from "./DeleteViewModal";
import { viewCreateRequest, viewDelete, viewUpdateRequest } from "store/views/action";
import { useDispatch, useSelector } from "react-redux";
import { Action, ThunkDispatch } from "@reduxjs/toolkit";
import { withTranslation } from "react-i18next";
import ArrangeSections from "./innerComponent/CreateModal/ArrangeSections";
import UpdateArrangeFields from "./innerComponent/UpdateModal/ArrangeSections";
import { ApplicationState } from "store";

const Arranger = ({ views, view, props, setViewId, setView, setFields, model, steps, setSteps,defaultSteps, groups} : any) => {

    const loading: any = useSelector((state: ApplicationState) => state.views.loading);
    const [isopen, setOpen] = useState<boolean>(false)
    const [viewAllOpwn, setViewAllOpen] = useState<boolean>(false);
    const [isDeleteOpen, setisDeleteOpen] = useState<boolean>(false);
    const [isEditOpen, setIsEditOpen] = useState<boolean>(false);
    const dispatch: ThunkDispatch<any, null, Action<string>> = useDispatch();
    const [record, setRecord]  = useState<any>(null);

    const onDelete = (id: any) => {
        const handleSuccess = () => {
            getViewList(dispatch, model, "overview",  true)
            setisDeleteOpen(false);
        }
        const handleFailure = () => {

        }
        dispatch(viewDelete(id, model, handleSuccess, handleFailure));
    }

    const onHandleselect = (item: any) => {
        if(item?.fields && isJson(item?.fields)) {
            setFields(JSON.parse(item?.fields))
        }
       }

      const onChange = (fields: any, viewname: any, viewId: any) => {
            if (viewId) {
                let data = {
                    "fields": JSON.stringify(fields),
                    "name": viewname,
                }
                const handleSuccess = (body: any) => {
                    getViewList(dispatch, model, "overview", true)
                    setIsEditOpen(false)
                }
                const handleFailure = () => {
    
                }
                dispatch(viewUpdateRequest(viewId, data, model, handleSuccess, handleFailure))
            }
            else {
                // setFields(fields)
                let data = {
                    "name": viewname,
                    "primary": "true",
                    "model": model,
                    "location": "overview",
                    "fields": JSON.stringify(fields),
                    "filters": JSON.stringify([]),
                }
                const handleSuccess = (body: any) => {
                    console.log("body", body)
                    getViewList(dispatch, model, "overview", true)
                    setOpen(false)
                }
                const handleFailure = () => {
    
                }
                dispatch(viewCreateRequest(data, model, handleSuccess, handleFailure))
            }
        }
    

    return (
        <React.Fragment> 
           {isEditOpen && <UpdateArrangeFields
                show={isEditOpen}
                onCloseClick={() => setIsEditOpen(false)}
                props={props}
                steps={steps}
                setSteps={setSteps}
                onChange={onChange}
                view={record}
                groups={groups}
                loading={loading}
            /> }               
            {viewAllOpwn  && <ViewAll
                show={viewAllOpwn}
                onCloseClick={() => setViewAllOpen(false)}
                viewlist={views}
                setisDeleteOpen={setisDeleteOpen}
                setIsEditOpen={setIsEditOpen}
                view={view}
                setRecord={setRecord}
                setViewId={setViewId}
                setView={setView}
                setFields={setFields}
                onChange={onChange}
                props={props}
                model={model}
                loading={loading}
            />}
            {isDeleteOpen && <DeleteViewModal
                show={isDeleteOpen}
                onCloseClick={() => setisDeleteOpen(false)}
                record={record}
                onDelete={onDelete}
                props={props}
            />}
            {isopen  && <ArrangeSections
                show={isopen}
                onCloseClick={() => setOpen(false)}
                props={props}
                steps={defaultSteps}
                setSteps={setSteps}
                onChange={onChange}
                loading={loading}
            />}
            <div>
                <span className="cursor-pointer">
                    <UncontrolledDropdown>
                        <DropdownToggle
                            href="#"
                            className="btn btn-ghost-primary btn-sm dropdown"
                            tag="button"
                            title="View Settings"
                        >
                            <i className="ri-settings-2-fill label-icon align-middle fs-16 me-2 text-primary"></i>
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-end">
                            <DropdownItem className="dropdown-item" onClick={() => setViewAllOpen(true)} >
                                <span className="fs-12 fw-normal" >
                                {props.t(`student.details.about.all_views`)}
                                </span>
                            </DropdownItem>
                            <DropdownItem className="dropdown-item" onClick={() => {setOpen(true)}}>
                                <span className="fs-12">
                                {props.t(`student.details.about.create_view`)}
                                </span>
                            </DropdownItem>
                            {view && view?.name !== 'Default' ?  <DropdownItem className="dropdown-item" onClick={() => {setIsEditOpen(true);setRecord(view);}}>
                                <span className="fs-12">
                                {props.t(`student.details.about.edit_view`)}
                                </span>
                            </DropdownItem>: null}
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </span>
            </div>
        </React.Fragment>
    )
}

export default withTranslation()(Arranger);